export default __webpack_public_path__ + "static/media/2508113.ff39583b.png";